import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { TeacherGroups } from './TeacherGroups';
import { TeacherList } from './TeacherList';

export const Teacher = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={TeacherList} />
    <Route path={`${props.match.path}/:teacherId`} component={TeacherGroups} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/teacher/Teacher.tsx